export enum EvaluationDomainTemplateScopeEnum
    {
       CustomerToRental = 1,
       CustomerToRentalEZ = 2,
       CustomerToDriver = 3,
       RentalToCustomer = 4,
       RepairToSupplier = 5
    }
